"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
var useTitle_1 = __importDefault(require("portal/hooks/useTitle"));
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Draft_1 = __importDefault(require("../Discussion/Draft"));
var CBATable_1 = __importDefault(require("../Orders/CBA/CBATable"));
var DNTable_1 = __importDefault(require("../Orders/DN/DNTable"));
var IRTable_1 = __importDefault(require("../Orders/IR/IRTable"));
var POTable_1 = __importDefault(require("../Orders/PO/POTable"));
var PRTable_1 = __importDefault(require("../Orders/PR/PRTable"));
var RFQTable_1 = __importDefault(require("../Orders/RFQ/RFQTable"));
var SCTable_1 = __importDefault(require("../Orders/SC/SCTable"));
var SCNTable_1 = __importDefault(require("../Orders/SCN/SCNTable"));
var hasProjectPermission_1 = require("./hasProjectPermission");
function ProjectOrders() {
    var _a;
    var TabPane = antd_1.Tabs.TabPane;
    var t = (0, react_i18next_1.useTranslation)().t;
    var params = (0, react_router_dom_1.useParams)();
    var projectId = params.projectId;
    var _b = (0, firestore_1.useDocument)(collectionsRef_1.projectsRef.doc(projectId)), projectSN = _b[0], loading = _b[1];
    var ordersSN = (0, firestore_1.useCollection)(collectionsRef_1.ordersRef.where("projectId", "==", projectId))[0];
    var IRsSN = (0, firestore_1.useCollection)(collectionsRef_1.IRsRef)[0];
    var CBAsSN = (0, firestore_1.useCollection)(collectionsRef_1.CBAsRef)[0];
    var IRData = IRsSN === null || IRsSN === void 0 ? void 0 : IRsSN.docs.filter(function (x) {
        var data = x.data();
        return data.status === "singedAndArchived";
    }).map(function (e) { var _a; return (_a = e.data()) === null || _a === void 0 ? void 0 : _a.scannedDocumentLink; });
    var viewOrdersTabPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, [
        "ordersTabView",
    ]);
    var viewIRsTabPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["IRsTabView"]);
    var viewRFQsTabPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, [
        "RFQsTabView",
    ]);
    var viewCBATabPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["CBATabView"]);
    var viewPOTabPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["POTabView"]);
    var viewDNTabPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["DNTabView"]);
    var viewSCNTabPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["SCNTabView"]);
    var viewPRTabPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["PRTabView"]);
    var viewOrderDiscussionTabPermission = (0, hasProjectPermission_1.hasProjectPermission)(projectId, [
        "orderDiscussionView",
    ]);
    var projectData = projectSN === null || projectSN === void 0 ? void 0 : projectSN.data();
    var projectStatus = projectData === null || projectData === void 0 ? void 0 : projectData.status;
    (0, useTitle_1.default)((_a = projectData === null || projectData === void 0 ? void 0 : projectData.name) !== null && _a !== void 0 ? _a : "");
    if (!projectSN ||
        loading ||
        !IRsSN ||
        !projectStatus ||
        !ordersSN ||
        !CBAsSN) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var ordersDataSource = ordersSN.docs.map(function (doc, idx) {
        return __assign(__assign({}, doc.data()), { index: idx, id: doc.id });
    });
    var ordersColumns = [
        {
            name: "ref",
            title: t("projects.irNo"),
            getCellValue: function (r) {
                var _a, _b, _c, _d;
                var IRref = (_d = (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.ref) !== null && _d !== void 0 ? _d : "";
                return IRref;
            },
        },
        {
            name: "description",
            title: t("projects.description"),
            getCellValue: function (r) { var _a, _b, _c; return (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.description; },
        },
        {
            name: "requestedBy",
            title: t("projects.requestedBy"),
            getCellValue: function (r) {
                var _a, _b, _c, _d, _e, _f;
                var id = (_d = (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.requestedBy) !== null && _d !== void 0 ? _d : "";
                return (_f = (_e = usersList_1.globalUsersData[id]) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : "";
            },
        },
        {
            name: "requestedAt",
            title: t("projects.requestedAt"),
            getCellValue: function (r) {
                var _a, _b, _c, _d;
                return (_d = (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.requestedAt) === null || _d === void 0 ? void 0 : _d.toDate().toLocaleString();
            },
        },
        {
            name: "status",
            title: t("common.status"),
            getCellValue: function (r) {
                var _a, _b, _c, _d, _e, _f;
                var IRStatus = (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.status;
                var CBAStatus = (_f = (_e = (_d = CBAsSN.docs) === null || _d === void 0 ? void 0 : _d.find(function (d) { return d.id === r.CBAId; })) === null || _e === void 0 ? void 0 : _e.data()) === null || _f === void 0 ? void 0 : _f.status;
                if (r.status === "preparingIR") {
                    return t("ir.".concat(IRStatus));
                }
                else if (r.status === "preparingCBA") {
                    return t("cba.".concat(CBAStatus));
                }
                else {
                    return t("orders.".concat(r.status));
                }
            },
        },
        {
            name: "completedAt",
            title: t("orders.completedAt"),
            getCellValue: function (r) {
                var _a, _b, _c, _d;
                return (_d = (_c = (_b = (_a = ordersSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.id; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.completedAt) === null || _d === void 0 ? void 0 : _d.toDate().toLocaleString();
            },
        },
        {
            name: "action",
            title: t("common.actions"),
            getCellValue: function (r) {
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/orders/".concat(r.id, "/"), type: "primary", style: { margin: "0px 5px" } }, { children: t("common.details") })) }) }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(antd_1.Tabs, __assign({ style: { minHeight: 60 } }, { children: [viewOrdersTabPermission ? ((0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "Orders" }, { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: ordersDataSource, columns: ordersColumns, getRowId: function (row) { return row.id; } }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({
                            table: "orders",
                        }), true) })) }), "orders")) : null, viewIRsTabPermission ? ((0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "IRs" }, { children: (0, jsx_runtime_1.jsx)(IRTable_1.default, { projectId: projectId }) }), "IRs")) : null, viewRFQsTabPermission ? ((0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "RFQs" }, { children: (0, jsx_runtime_1.jsx)(RFQTable_1.default, { projectId: projectId }) }), "RFQs")) : null, viewCBATabPermission ? ((0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "CBA" }, { children: (0, jsx_runtime_1.jsx)(CBATable_1.default, { projectId: projectId }) }), "CBA")) : null, viewPOTabPermission ? ((0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "PO" }, { children: (0, jsx_runtime_1.jsx)(POTable_1.default, { projectId: projectId }) }), "PO")) : null, viewDNTabPermission ? ((0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "DN" }, { children: (0, jsx_runtime_1.jsx)(DNTable_1.default, { projectId: projectId }) }), "DN")) : null, (0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "SC" }, { children: (0, jsx_runtime_1.jsx)(SCTable_1.default, { projectId: projectId }) }), "DC"), viewSCNTabPermission ? ((0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "SCN" }, { children: (0, jsx_runtime_1.jsx)(SCNTable_1.default, { projectId: projectId }) }), "SCN")) : null, viewPRTabPermission ? ((0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "PR" }, { children: (0, jsx_runtime_1.jsx)(PRTable_1.default, { projectId: projectId }) }), "PR")) : null, viewOrderDiscussionTabPermission ? ((0, jsx_runtime_1.jsx)(TabPane, __assign({ tab: "Discussions" }, { children: (0, jsx_runtime_1.jsx)(Draft_1.default, { kind: "project", docId: projectId, viewInput: true }) }), "discussions")) : null] })) }));
}
exports.default = ProjectOrders;
